export const ADMIN_ROLE = "Admin"
export const ADMIN_ORGANIZATION = "Admin"

export const ORGANIZATIONS = [
    { value: "136", label: "136" },
    { value: "Lille", label: "Lille" },
    { value: "Nanterre", label: "Nanterre" },
    { value: "PSG", label: "PSG" },
    { value: "Reims", label: "Reims" },
    { value: "PFC", label: "PFC" },
]

export const QUIZ_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    "136",
    "Lille",
    "Nanterre",
    "PSG",
    "Reims",
    "PFC",
]
export const QUIZ_AUTHORISED_ROLES = [ADMIN_ROLE, "Content"]
export const QUIZ_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
]
export const QUIZ_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES = [ADMIN_ROLE]

export const BINGO_AUTHORISED_ORGANIZATIONS = [ADMIN_ORGANIZATION]
export const BINGO_AUTHORISED_ROLES = [ADMIN_ROLE]
export const BINGO_CREATE_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    ...QUIZ_AUTHORISED_ORGANIZATIONS,
]
export const BINGO_CREATE_AUTHORISED_ROLES = [
    ADMIN_ROLE,
    ...QUIZ_AUTHORISED_ROLES,
]
export const BINGO_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
]
export const BINGO_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES = [ADMIN_ROLE]

export const CLICK_AND_COLLECT_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    "136",
    "PSG",
]
export const CLICK_AND_COLLECT_AUTHORISED_ROLES = [ADMIN_ROLE, "Content"]
export const CLICK_AND_COLLECT_CREATE_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    "136",
    "PSG",
    ...QUIZ_AUTHORISED_ORGANIZATIONS,
]
export const CLICK_AND_COLLECT_CREATE_AUTHORISED_ROLES = [
    ADMIN_ROLE,
    "Content",
    ...QUIZ_AUTHORISED_ROLES,
]
export const CLICK_AND_COLLECT_DELETE_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
]
export const CLICK_AND_COLLECT_DELETE_AUTHORISED_ROLES = [ADMIN_ROLE]
export const CLICK_AND_COLLECT_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS =
    [ADMIN_ORGANIZATION]
export const CLICK_AND_COLLECT_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES = [
    ADMIN_ROLE,
]
export const CLICK_AND_COLLECT_UPDATE_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    "136",
    "PSG",
]
export const CLICK_AND_COLLECT_UPDATE_AUTHORISED_ROLES = [ADMIN_ROLE, "Content"]

export const CROSSBAR_AUTHORISED_ORGANIZATIONS = [ADMIN_ORGANIZATION]
export const CROSSBAR_AUTHORISED_ROLES = [ADMIN_ROLE]
export const CROSSBAR_CREATE_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    ...QUIZ_AUTHORISED_ORGANIZATIONS,
]
export const CROSSBAR_CREATE_AUTHORISED_ROLES = [
    ADMIN_ROLE,
    ...QUIZ_AUTHORISED_ROLES,
]
export const CROSSBAR_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
]
export const CROSSBAR_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES = [ADMIN_ROLE]

export const DIAPORAMA_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    "136",
    "Lille",
    "Nanterre",
    "PSG",
    "Reims",
    "PFC",
]
export const DIAPORAMA_AUTHORISED_ROLES = [ADMIN_ROLE, "Content"]
export const DIAPORAMA_CREATE_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    ...QUIZ_AUTHORISED_ORGANIZATIONS,
]
export const DIAPORAMA_CREATE_AUTHORISED_ROLES = [
    ADMIN_ROLE,
    ...QUIZ_AUTHORISED_ROLES,
]
export const DIAPORAMA_MESSAGES_DELETE_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
]
export const DIAPORAMA_MESSAGES_DELETE_AUTHORISED_ROLES = [ADMIN_ROLE]
export const DIAPORAMA_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
]
export const DIAPORAMA_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES = [ADMIN_ROLE]

export const ENTITY_DELETE_AUTHORISED_ORGANIZATIONS = [ADMIN_ORGANIZATION]
export const ENTITY_DELETE_AUTHORISED_ROLES = [ADMIN_ROLE]

export const EVENT_AUTHORISED_ORGANIZATIONS = [ADMIN_ORGANIZATION]
export const EVENT_AUTHORISED_ROLES = [ADMIN_ROLE]
export const EVENT_CREATE_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    ...QUIZ_AUTHORISED_ORGANIZATIONS,
]
export const EVENT_CREATE_AUTHORISED_ROLES = [
    ADMIN_ROLE,
    ...QUIZ_AUTHORISED_ROLES,
]
export const EVENT_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
]
export const EVENT_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES = [ADMIN_ROLE]

export const WORKFORCE_AUTHORISED_ORGANIZATIONS = [ADMIN_ORGANIZATION]
export const WORKFORCE_AUTHORISED_ROLES = [ADMIN_ROLE]
export const WORKFORCE_CREATE_AUTHORISED_ORGANIZATIONS =
    QUIZ_AUTHORISED_ORGANIZATIONS
export const WORKFORCE_CREATE_AUTHORISED_ROLES = QUIZ_AUTHORISED_ROLES
export const WORKFORCE_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS =
    QUIZ_AUTHORISED_ORGANIZATIONS
export const WORKFORCE_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES =
    QUIZ_AUTHORISED_ROLES

//html page auth

export const HTML_PAGE_AUTHORISED_ORGANIZATIONS = QUIZ_AUTHORISED_ORGANIZATIONS
export const HTML_PAGE_AUTHORISED_ROLES = QUIZ_AUTHORISED_ROLES
export const HTML_PAGE_CREATE_AUTHORISED_ORGANIZATIONS =
    QUIZ_AUTHORISED_ORGANIZATIONS
export const HTML_PAGE_CREATE_AUTHORISED_ROLES = QUIZ_AUTHORISED_ROLES
export const HTML_PAGE_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS =
    QUIZ_AUTHORISED_ORGANIZATIONS
export const HTML_PAGE_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES =
    QUIZ_AUTHORISED_ROLES

//places auth

export const PLACE_AUTHORISED_ORGANIZATIONS = [ADMIN_ORGANIZATION]
export const PLACE_AUTHORISED_ROLES = [ADMIN_ROLE]
export const PLACE_CREATE_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    ...QUIZ_AUTHORISED_ORGANIZATIONS,
]
export const PLACE_CREATE_AUTHORISED_ROLES = [
    ADMIN_ROLE,
    ...QUIZ_AUTHORISED_ROLES,
]
export const PLACE_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
]
export const PLACE_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES = [ADMIN_ROLE]

//pronosticsv2 auth

export const PRONOSTICSV2_AUTHORISED_ORGANIZATIONS = [ADMIN_ORGANIZATION]
export const PRONOSTICSV2_AUTHORISED_ROLES = [ADMIN_ROLE]
export const PRONOSTICSV2_CREATE_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    ...QUIZ_AUTHORISED_ORGANIZATIONS,
]
export const PRONOSTICSV2_CREATE_AUTHORISED_ROLES = [
    ADMIN_ROLE,
    ...QUIZ_AUTHORISED_ROLES,
]
export const PRONOSTICSV2_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
]
export const PRONOSTICSV2_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES = [
    ADMIN_ROLE,
]

export const CHAMPIONSHIP_AUTHORISED_ORGANIZATIONS = [ADMIN_ORGANIZATION]
export const CHAMPIONSHIP_AUTHORISED_ROLES = [ADMIN_ROLE]
export const CHAMPIONSHIP_CREATE_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    ...QUIZ_AUTHORISED_ORGANIZATIONS,
]
export const CHAMPIONSHIP_CREATE_AUTHORISED_ROLES = [
    ADMIN_ROLE,
    ...QUIZ_AUTHORISED_ROLES,
]
export const CHAMPIONSHIP_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
]
export const CHAMPIONSHIP_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES = [
    ADMIN_ROLE,
]

//sonometer auth

export const SONOMETER_AUTHORISED_ORGANIZATIONS = [ADMIN_ORGANIZATION]
export const SONOMETER_AUTHORISED_ROLES = [ADMIN_ROLE]
export const SONOMETER_CREATE_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
    ...QUIZ_AUTHORISED_ORGANIZATIONS,
]
export const SONOMETER_CREATE_AUTHORISED_ROLES = [
    ADMIN_ROLE,
    ...QUIZ_AUTHORISED_ROLES,
]
export const SONOMETER_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS = [
    ADMIN_ORGANIZATION,
]
export const SONOMETER_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES = [ADMIN_ROLE]

export const ADMIN_MENU_AUTHORIZED_ORGANIZATIONS = QUIZ_AUTHORISED_ORGANIZATIONS
export const ADMIN_MENU_AUTHORIZED_ROLES = ["Admin", "Content"]
